import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
//引入store
import store from '../store/index'

import maps from './maps'

let baseRoute = [{
		path: '/login',
		name: 'login',
		component: (resolve) => require(['../pages/login.vue'], resolve)
	}, {
		path: '/mian',
		name: 'main',
		component: (resolve) => require(['../pages/main.vue'], resolve),
		children: maps
	},
	{
		path: '/401',
		name: '401',
		component: (resolve) => require(['../pages/common/401.vue'], resolve)
	}, {
		path: '/404',
		name: '404',
		component: (resolve) => require(['../pages/common/404.vue'], resolve)
	}, {
		path: '/',
		redirect: '/login'
	},
];

const router = new Router({
	routes: baseRoute
});

router.beforeEach((to, from, next) => {
	window.document.title = '证书管理系统2.1'
	next();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js